import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import { Input, Label } from 'reactstrap'
const SourcingSellerPicker = ({ value, label, onChange }) => {
  const [query, setQuery] = useState(label || '')
  const [options, setOptions] = useState([])
  const [error, setError] = useState('')
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [highlighted, setHighlighted] = useState(0)

  useEffect(() => {
    if (value && label) setQuery(label)
  }, [value, label])

  useEffect(() => {
    let active = true
    if (!open || query.trim().length < 2) {
      setOptions([])
      setLoading(false)
      return () => { active = false }
    }
    setLoading(true)
    const timer = setTimeout(async () => {
      try {
        const { data } = await axios.get('/api/v2/admins/buying/deals/seller_users', { params: { q: query.trim() } })
        if (active) { setOptions(data.data || []); setHighlighted(0); setError('') }
      } catch (_) {
        if (active) { setOptions([]); setError('Gagal mencari seller.') }
      } finally {
        if (active) setLoading(false)
      }
    }, 300)
    return () => { active = false; clearTimeout(timer) }
  }, [query, open])

  const selectSeller = (detail) => {
    onChange(detail)
    setQuery(detail.name || '')
    setOptions([])
    setOpen(false)
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') setOpen(false)
    if (!open || !options.length) return
    if (event.key === 'ArrowDown') { event.preventDefault(); setHighlighted(index => (index + 1) % options.length) }
    if (event.key === 'ArrowUp') { event.preventDefault(); setHighlighted(index => (index - 1 + options.length) % options.length) }
    if (event.key === 'Enter') { event.preventDefault(); selectSeller(options[highlighted]) }
  }

  return <div className='mb-3'>
    <Label>Supplier / Seller Detail *</Label>
    <small className='text-muted d-block mb-2'>Untuk Seller Settlement: pilih User Detail seller yang sudah terdaftar, termasuk detail non-primary. Email seller tidak wajib saat sourcing. Nama yang hanya diketik tanpa dipilih tidak akan tersimpan.</small>
    <div className='position-relative' onBlur={e => { if (!e.currentTarget.contains(e.relatedTarget)) setOpen(false) }}>
      <Input
        aria-label='Search seller detail'
        aria-expanded={open && query.trim().length >= 2}
        autoComplete='off'
        value={query}
        placeholder='Cari nama, telepon, atau email detail (minimum 2 karakter)'
        onFocus={() => { if (!value) setOpen(true) }}
        onChange={e => {
          setQuery(e.target.value)
          setOpen(true)
          setOptions([])
          setError('')
          if (value) onChange(null)
        }}
        onKeyDown={handleKeyDown}
      />
      {open && query.trim().length >= 2 && (
        <div className='position-absolute w-100 bg-white border rounded shadow-sm' style={{ zIndex: 1050, maxHeight: 300, overflowY: 'auto' }}>
          {loading ? <div className='px-3 py-2 text-muted'>Mencari seller...</div> : options.length ? options.map((user, index) => (
            <button
              key={user.id}
              type='button'
              className={`dropdown-item text-left${index === highlighted ? ' active' : ''}`}
              onMouseDown={e => e.preventDefault()}
              onClick={() => selectSeller(user)}
            >
              {user.name || '-'} — Detail #{user.user_detail_id}{user.phone ? ` · ${user.phone}` : ''}{user.email ? ` · ${user.email}` : ''}
            </button>
          )) : <div className='px-3 py-2 text-muted'>Seller Detail tidak ditemukan.</div>}
        </div>
      )}
    </div>
    {error && <small className='text-danger'>{error}</small>}
    <small>Detail belum ada? <a href='/app/sales/users' target='_blank' rel='noopener noreferrer'>Buka User List untuk menambah User Detail</a> pada akun yang sudah ada, lalu pilih detail tersebut di sini.</small>
  </div>
}
SourcingSellerPicker.propTypes = { value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), label: PropTypes.string, onChange: PropTypes.func.isRequired }
export default SourcingSellerPicker
